import { connect } from 'react-redux'
import WeeklyTotalPay from '../views/WeeklyTotalPay'
import { getWeeklyTotalPay, listUnionInfo } from '../action/userAction'

function mapStateToProps(state, ownProps) {
  return {
    weekly_total_pay: state.getIn(['data', 'weekly_total_pay']),
    error: state.getIn(['data', 'weekly_total_pay_error']),
    union_info: state.getIn(['data','union_info'])
  };
}

const mapDispatchToProps = (dispatch, ownProps) => ({
  onLoad: () => {
    dispatch(getWeeklyTotalPay());
    dispatch(listUnionInfo());
  }
});

const WeeklyTotalPayContainer = connect(
  mapStateToProps,
  mapDispatchToProps
)(WeeklyTotalPay);

export default WeeklyTotalPayContainer;